import React, { memo } from "react";

import { Box } from "@UI/Components/Box/Box";
import { Button } from "@UI/Components/Button/Button";
import { Flex } from "@UI/Components/Flex/Flex";
import { Icon } from "@UI/Components/Icon/Icon";
import { Text } from "@UI/Components/Text/Text";
import { CircleInfo } from "@UI/Components/Icons/CircleInfo";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "../../messages";

export interface IEmailSuggestionProps {
  /** The likelier spelling. Whether there is one to show is the screen's call. */
  suggestion: string;
  /** Takes the correction into the field. */
  onAccept: () => void;
  /** Keeps what was typed, and is remembered for that address. */
  onDismiss: () => void;
}

/** "Did you mean …?" — advisory: both answers let the visitor carry on. */
export const EmailSuggestion = memo(
  ({ suggestion, onAccept, onDismiss }: IEmailSuggestionProps) => (
    <Box role="status" padding="12px" borderRadius="8px" background="orange.50">
      <Flex gap="8px" alignItems="flex-start">
        <Icon
          as={CircleInfo}
          width="14px"
          height="14px"
          marginTop="3px"
          flexShrink={0}
          color="orange.500"
          aria-hidden
        />
        <Text
          flex="1"
          fontSize="sm"
          lineHeight="1.5"
          color="orange.500"
          minWidth={0}
        >
          <FormattedMessage
            {...messages["taskCreation.auth.email.suggestion"]}
            values={{ email: suggestion }}
          />
        </Text>
      </Flex>
      <Flex justifyContent="center" gap="48px" marginTop="8px">
        <Button
          variant="link"
          fontSize="sm"
          fontWeight="700"
          color="orange.500"
          textDecoration="none"
          _hover={{ textDecoration: "none" }}
          onClick={onAccept}
        >
          <FormattedMessage
            {...messages["taskCreation.auth.email.suggestion.accept"]}
          />
        </Button>
        <Button
          variant="link"
          fontSize="sm"
          fontWeight="700"
          color="orange.500"
          textDecoration="none"
          _hover={{ textDecoration: "none" }}
          onClick={onDismiss}
        >
          <FormattedMessage
            {...messages["taskCreation.auth.email.suggestion.dismiss"]}
          />
        </Button>
      </Flex>
    </Box>
  )
);

EmailSuggestion.displayName = "EmailSuggestion";
